module.exports = __webpack_public_path__ + "img/img11.3e947217.png";